
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{staticClass:"background",attrs:{"fill":"#c8c9ca","cx":"12","cy":"12","r":"12"}}),_c('circle',{staticClass:"user",attrs:{"fill":"#f5f6f7","cx":"12","cy":"9","r":"5"}}),_c('path',{staticClass:"user",attrs:{"d":"M22 24l-10 1-10-1c0-5.5 4.5-10 10-10s10 4.5 10 10z","fill":"#f5f6f7"}})])
          )
        }
      }
    